import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {Permission} from '../../../models/security/permission';
import {PermissionService} from '../../../service/security/service-permission';
import {PermissionCodeService} from '../../../service/security/service-permissioncode';
import {PermissionCode} from '../../../models/security/permissioncode';
import {PermissionsComponent} from './permission.component';
import {GroupPermissionService} from '../../../service/security/service-grouppermission';

@Component({
  templateUrl: './dsp.component.html'

})
export class DSPermissionsComponent implements OnInit, AfterViewInit {
  public language = language;
  public groupId: number= 0;
  public onClose: Subject<boolean>;
  public dataTree: Permission [];
  public dataPermission: Permission[]=[];
  public dataPermissionCode: PermissionCode[]=[];
  constructor(public toastr: ToastrService,
              public _bsModalRef: BsModalRef,
              public permissionService: PermissionService,
              public permissionCodeService: PermissionCodeService,
              public groupPermissionService: GroupPermissionService,
              public bsModalService: BsModalService
  ) {
  }

  ngAfterViewInit() {

  }

  ngOnInit(): void {
    this.onClose = new Subject();

  }
  public permision(id: number): void {
    const modalEdit = this.bsModalService.show(PermissionsComponent, {class: 'modal-lg'});
    (<PermissionsComponent>modalEdit.content).showPermision(
      id

    );
    (<PermissionsComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.show(this.groupId);

      }
    });
  }
  public deleteItem(code: string)
  {
    this.groupPermissionService.deleteByGroupAndCode(this.groupId, code).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.show(this.groupId);


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public show(id: number): void {
    this.groupId=id;
    this.permissionService.getAllByGroupId(id).subscribe(data=> this.dataPermission= data);
    this.permissionCodeService.getAllByGroupId(id).subscribe(data=> this.dataPermissionCode= data);

  }
  public getCode(id: number): PermissionCode[]
  {
    return this.dataPermissionCode.filter(x=>x.funcGroupId == id);
  }


  public onSelect(): void {

    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

  public nodeChecked(args): void {

  }

}
